import React from 'react';

const EditIcon = ({ stroke = '#A0A0AB' }: { stroke?: string }) => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.8501 1.5H7.3501C3.6001 1.5 2.1001 3 2.1001 6.75V11.25C2.1001 15 3.6001 16.5 7.3501 16.5H11.8501C15.6001 16.5 17.1001 15 17.1001 11.25V9.75"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6301 2.26495L6.7201 8.17495C6.4951 8.39995 6.2701 8.84245 6.2251 9.16495L5.9026 11.4224C5.7826 12.2399 6.3601 12.8099 7.1776 12.6974L9.4351 12.3749C9.7501 12.3299 10.1926 12.1049 10.4251 11.8799L16.3351 5.96995C17.3551 4.94995 17.8351 3.76495 16.3351 2.26495C14.8351 0.764945 13.6501 1.24495 12.6301 2.26495Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7826 3.1123C12.2851 4.9048 13.6876 6.3073 15.4876 6.8173"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EditIcon;
